import {useContext, createContext} from "react";

export const AppContext = createContext(null);
export const ManageAssignmentContext = createContext(null);
export const ManageQuestionContext = createContext(null);
export const ReviewQuestionContext = createContext(null);
export const DashboardContext = createContext(null);

export function useAppContext() {
  return useContext(AppContext);
}

export function useManageAssignmentContext() {
  return useContext(ManageAssignmentContext);
}

export function useManageQuestionContext() {
  return useContext(ManageQuestionContext);
}

export function useReviewQuestionContext() {
  return useContext(ReviewQuestionContext);
}

export function useDashboardContext() {
  return useContext(DashboardContext);
}
